<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('administration.mobile_feature.about_us.about_us') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('administration.mobile_feature.about_us.about_us'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-4">
            <ts-button
              color="info"
              outline
              @click="$router.push({ name: 'about-create' })"
            >
              {{ $t('add_new') }}
            </ts-button>
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          <td class="kh-font">
            {{ $store.getters.limitStringShow(record.content_kh) }}
          </td>
          <td>{{ $store.getters.limitStringShow(record.content_en) }}</td>
          <td class="text-center">
            <a
              href="#"
              class="mr-2 text-primary"
              v-tooltip="$t('edit')"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination"> </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'about',
  data() {
    return {
      loading: false
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('about', ['resources', 'pagination']),
    columns() {
      return [
        { name: this.$t('administration.mobile_feature.about_us.kh_content') },
        { name: this.$t('administration.mobile_feature.about_us.en_content') },
        {
          name: this.$t('administration.mobile_feature.about_us.actions'),
          style: 'text-align:center; width: 7%;'
        }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('about/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.$store.commit('about/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'about-edit',
        params: { id: record.company_id }
      })
    }
  }
}
</script>
